<template>
  <div class="cp-shell">
    <transition name="toast">
      <div
        v-if="baseToast.message"
        class="cp-toast"
        :class="'is-' + (baseToast.type || 'info')"
      >
        <span class="dot"></span>
        <span>{{ baseToast.message }}</span>
      </div>
    </transition>

    <header class="cp-header">
      <div>
        <div class="eyebrow">Account</div>
        <h1>Change Password</h1>
        <p class="subtitle">Update your account password. Choose something strong that you don't reuse elsewhere.</p>
      </div>
    </header>

    <change-password-form @change-password="changePassword"></change-password-form>
  </div>
</template>

<script>
import http from "../../http-common.js";
import ChangePasswordForm from "../../components/sub-admin/ChangePasswordForm.vue";

export default {
  name: "change-password",
  components: { ChangePasswordForm },
  data() {
    return {
      baseToast: {
        type: "",
        message: "",
      },
    };
  },
  methods: {
    async changePassword(data) {
      try {
        const response = await http.post("/subadmin/change-password", data);
        if (response.status === 200) {
          this.baseToast = { type: 'success', message: response.data.message };
          setTimeout(() => { this.baseToast = { type: '', message: '' }; }, 3200);
        }
      } catch (error) {
        this.baseToast = { type: 'error', message: error.response?.data?.message || "Failed to change password" };
        setTimeout(() => { this.baseToast = { type: '', message: '' }; }, 3800);
      }
    },
  },
};
</script>

<style scoped>
.cp-shell {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 20px;
  background: linear-gradient(180deg, #fbfaf7 0%, #f4f0e5 100%);
  overflow-y: auto;
}

.cp-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.eyebrow {
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #1B2A47;
  font-weight: 600;
  margin-bottom: 4px;
}
.cp-header h1 {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.1;
  margin: 0;
}
.subtitle {
  font-size: 13px;
  color: #64748b;
  margin: 4px 0 0;
  max-width: 640px;
}

/* Toast */
.cp-toast {
  position: fixed;
  top: 24px; right: 24px;
  z-index: 60;
  background: #0f172a; color: #fff;
  padding: 12px 18px;
  border-radius: 12px;
  font-size: 13px; font-weight: 500;
  display: inline-flex; align-items: center; gap: 10px;
  box-shadow: 0 12px 30px -10px rgba(15, 23, 42, 0.4);
  max-width: 420px;
}
.cp-toast .dot { width: 8px; height: 8px; border-radius: 999px; background: #94a3b8; flex-shrink: 0; }
.cp-toast.is-success { background: #059669; }
.cp-toast.is-success .dot { background: #a7f3d0; }
.cp-toast.is-error { background: #dc2626; }
.cp-toast.is-error .dot { background: #fecaca; }

.toast-enter-active, .toast-leave-active { transition: all 0.24s cubic-bezier(0.4, 0, 0.2, 1); }
.toast-enter-from, .toast-leave-to { transform: translateY(-12px); opacity: 0; }
</style>
